const normalizeToGeneralSettings = data => {
  const { businessResponse, defaultTeamResponse } = data;
  const { meta, body: businesses } = businessResponse;
  const { body: defaultTeam } = defaultTeamResponse;
  const business = businesses[0];

  return {
    id: business.id,
    enableHumanAssistance: business.to_assistant,
    requestsPii: business.requests_pii,
    liveAgentChatTool: business.chat_tool,
    enableSmallTalk: business.run_smalltalk,
    activeBots: business.domain_list,
    defaultBot: business.default_domain,
    fallbackBot: business.fallback_domain,
    businessName: business.name,
    businessViaName: business.via_name,
    previewText: business.preview_text,
    order: business.order,
    activePartners: business.partners.map(id => meta.partner_id_map[id]),
    defaultTeam: defaultTeam.team_data ? defaultTeam.team_data.name : '',
    collectFeedback: business.online,
    collectFeedbackMultiple: business.multiple_feedbacks,
    collectFeedbackDelay: business.feedback_delay,
    triggerIdList: business.trigger_id_list,
    languageCode: business.language_code,
    online: business.online,
    pipelineVersion: business.pipeline_version,
  };
};

export default normalizeToGeneralSettings;
